import FoodBankOutlinedIcon from "@mui/icons-material/FoodBankOutlined";
import { Box, Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { getNearByGigs } from "../firebase/gig";
import { Gig } from "../interfaces/Gig";
import { RootState } from "../redux/store";
import GigCard from "./GigCard";
import NoDataUI from "./NoDataUI";

const NearbyGigs = () => {
  const [gigsData, setGigsData] = useState<Gig[]>([]);
  const userAddress = useSelector(
    (state: RootState) => state.user.user.address
  );
  const userUid = useSelector((state: RootState) => state.user.user.uid);

  async function fetchNearByGigs() {
    if (userAddress) {
      const nearByGigs: Gig[] = await getNearByGigs(
        userAddress.lat,
        userAddress.lng,
        userUid || null
      );
      nearByGigs && setGigsData(nearByGigs);
    }
  }

  useEffect(() => {
    fetchNearByGigs();
  }, []);

  return (
    <Box sx={{ mt: 3 }}>
      {gigsData.length > 0 ? (
        <Grid container spacing={3}>
          {gigsData.map((gig, index) => {
            return (
              <Grid key={index} item xs={12} md={12}>
                <GigCard gigStatusDisplay={true} gig={gig} />
              </Grid>
            );
          })}
        </Grid>
      ) : (
        <NoDataUI
          Icon={FoodBankOutlinedIcon}
          displayMessage={"No gigs near you"}
        />
      )}
    </Box>
  );
};

export default NearbyGigs;
